module.exports = __webpack_public_path__ + "img/7milk3_hand.59b96065.png";